import script from "./DefShare.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefShare.vue?vue&type=script&lang=ts&setup=true"

import "./DefShare.vue?vue&type=style&index=0&id=b22dd1ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b22dd1ca"]])

export default __exports__